import React from "react";

// 2026-10-31 — chat: "CB: It's not clear whether it's Live\Paper..display Live\Paper...
// even for other setups also". One badge for every setup's trade rows:
//   LIVE            real broker order that filled
//   LIVE · NO FILL  a real order went out but never filled (rejected / chase timeout)
//   PAPER           simulated only (hover: why it stayed paper)
const isRejected = (t) => String(t.live_status || "").toLowerCase() === "rejected" || (!!t.live_error && !Number(t.live_avg_fill_price));
const hasFill = (t) => Number(t.live_avg_fill_price) > 0 || Number(t.live_filled_qty) > 0 ||
  ["complete", "filled"].includes(String(t.live_broker_status || t.live_status || "").toLowerCase());

export const tradeMode = (t) => {
  if (!t) return "PAPER";
  if (t.live_trade) {
    if (isRejected(t)) return "REJECTED";
    if (!hasFill(t) && (t.close_reason === "BUY_CHASE_TIMEOUT" || /unfilled|timeout/i.test(String(t.live_skip_reason || "")))) return "NO_FILL";
    return "LIVE";
  }
  if (t.live_error) return "REJECTED";
  return "PAPER";
};

export const ModeBadge = ({ t, className = "ml-2" }) => {
  const mode = tradeMode(t);
  const cfg = {
    LIVE: { label: "LIVE", color: "var(--bull)", title: "Real broker order — filled" },
    NO_FILL: { label: "LIVE · NO FILL", color: "var(--warn, #f39c12)", title: "A real order was sent but never filled — tracked as paper" },
    REJECTED: { label: "LIVE · REJECTED", color: "var(--bear)",
                title: `Real order rejected — tracked as paper${t?.live_error_message ? `: ${t.live_error_message}` : t?.live_error ? `: ${t.live_error}` : ""}` },
    PAPER: { label: "PAPER", color: "var(--text-muted-2, #8a8070)",
             title: t?.live_skip_reason ? `Paper only — ${t.live_skip_reason}` : "Paper only (simulated)" },
  }[mode];
  return (
    <span className={`${className} inline-block px-1.5 py-0.5 text-[8px] uppercase tracking-wider border rounded-sm font-mono-data align-middle`}
          style={{ color: cfg.color, borderColor: cfg.color }} title={cfg.title} data-testid="trade-mode-badge">
      {cfg.label}
    </span>
  );
};

export default ModeBadge;
